import React from "react"
import FontAwesome from "react-fontawesome"

export default function WalletAddress({ address, shouldShow, onClick }) {

  const textWallet = address
    ? (shouldShow
      ? address
      : `${ address.substring(0, 7) }...${ address.substring(address.length - 5) }`)
    : '-'

  return <span className="flex-row-simple">
    <span>{ textWallet }</span>
    { textWallet !== '-' && <span className="px-10 cursor-pointer"
      title={ shouldShow ? 'Hide' : 'Show' }
      onClick={ onClick }>
      <FontAwesome name={ shouldShow ? 'eye-slash' : 'eye' } />
    </span>}
  </span>
}



// WEBPACK FOOTER //
// ./src/components/fragments/WalletAddress.js